import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import { useState } from "react";

export const AddOptionPopover = ({ label = "", children }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	return (
		<Box>
			<Button
				aria-describedby={id}
				// variant="o"

				onMouseEnter={handleClick}
				onMouseLeave={() => {
					// Delay closing to allow hovering popover
					setTimeout(() => {
						if (!document.querySelector(`#${id}`)) {
							handleClose();
						}
					}, 1000);
				}}
			>
				{label}
			</Button>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				PaperProps={{
					onMouseEnter: () => clearTimeout(), // Keep open on hover
					onMouseLeave: handleClose, // Close when leaving popover
				}}
			>
				<Box p={3} sx={{ display: "flex", gap: 3 }}>
					{children}
				</Box>
			</Popover>
		</Box>
	);
};
